/*
 * Show multiple promos applied
 */
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Tooltip,
    Text,
    ListItem,
    VStack,
    HStack
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {UnorderedList} from '@chakra-ui/react'
import {InfoIcon} from '@chakra-ui/icons'

const ShowPromotionsList = ({productPromotions}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768 || 'ontouchstart' in window)
        }

        checkMobile()
        window.addEventListener('resize', checkMobile)

        return () => window.removeEventListener('resize', checkMobile)
    }, [])
    const tooltipContent = (
        <VStack align="start" spacing={2} p={2}>
            <Text fontWeight="bold" fontSize="xl" mb={1}>
                <FormattedMessage defaultMessage="Applied Savings" id="pdp_applied_savings" />
            </Text>
            <UnorderedList spacing={1} ml={4}>
                {productPromotions?.map((promotion) => {
                    return (
                        promotion?.calloutMsg && (
                            <ListItem fontSize="md">{parse(promotion.calloutMsg)}</ListItem>
                        )
                    )
                })}
            </UnorderedList>
        </VStack>
    )

    const handleClick = (e) => {
        if (isMobile) {
            e.preventDefault()
            setIsOpen(!isOpen)
        }
    }

    const handleMouseEnter = () => {
        if (!isMobile) {
            setIsOpen(true)
        }
    }

    const handleMouseLeave = () => {
        if (!isMobile) {
            setIsOpen(false)
        }
    }

    // Close tooltip when clicking outside on mobile
    useEffect(() => {
        if (isMobile && isOpen) {
            const handleClickOutside = (e) => {
                if (!e.target.closest('[data-tooltip-trigger]')) {
                    setIsOpen(false)
                }
            }

            document.addEventListener('click', handleClickOutside)
            return () => document.removeEventListener('click', handleClickOutside)
        }
    }, [isMobile, isOpen])

    return (
        <Box>
            <HStack spacing={2} align="center" color={'textColor'} lineHeight={'105%'}>
                <Text fontWeight={'extrabold'}>
                    <FormattedMessage
                        defaultMessage="Multiple Promotions Applied"
                        id="pdp_multiple_promos"
                    />
                </Text>
                <Tooltip
                    label={tooltipContent}
                    placement="bottom"
                    hasArrow
                    borderRadius="lg"
                    bg={'white'}
                    color="black"
                    p={3}
                    fontSize="sm"
                    maxW={{base: '320px', sm: '400px'}}
                    openDelay={isMobile ? 0 : 200}
                    closeDelay={isMobile ? 0 : 100}
                    boxShadow="0px 2px 7px 0px rgba(0, 0, 0, 0.25)"
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                >
                    <Box
                        cursor="pointer"
                        data-tooltip-trigger
                        onClick={handleClick}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <InfoIcon w={4} h={4} role="img" aria-label="information icon" />
                    </Box>
                </Tooltip>
            </HStack>
        </Box>
    )
}

ShowPromotionsList.propTypes = {
    productPromotions: PropTypes.object
}

export default ShowPromotionsList
